/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
    color: PropTypes.oneOf([
        'text-light',
        'primary',
        'error',
        'success',
        'white',
        'action',
    ]).isRequired,
};

const defaultProps = {
    ...commonDefaultProps,
    color: 'primary',
    componentClass: 'a',
};

const Link = (props) => {
    const classNames = [
        'c-link',
        props.color === 'error' ? 'c-link--error' : '',
        props.color === 'action' ? 'c-link--action' : '',
        props.color === 'text-light' ? 'c-link--text-light' : '',
        props.color === 'primary' ? 'c-link--primary' : '',
        props.color === 'success' ? 'c-link--success' : '',
        props.color === 'white' ? 'c-link--white' : '',
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    return (
        <props.componentClass
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        >
            {props.children}
        </props.componentClass>
    );
};

Link.propTypes = propTypes;

Link.defaultProps = defaultProps;

export default Link;
